import { createStore } from "vuex";
import { login } from "@/API/API";
import cart from "@/store/module/cart";
import router from "@/router";
import httpClient from "@/API/HttpClient";
import { getUserInfo, postFCMToken } from "../API/API";
import fcmToken from "../utils/fcm";

export default createStore({
  state: {
    token: localStorage.getItem("token"),
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {},
    factor: {
      sho_Mobile: "",
      taF_NAME: "",
      tedad: "",
      saloonID: "",
      desK_NUMBER: "",
      deliveryDelay: "",
      description: "",
      paymentType: "",
      cartTrackingNo: "",
      PosNo: 0,
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    REMOVE_TOKEN(state) {
      state.token = "";
      localStorage.removeItem("token");
    },
    SET_INITIAL_FACTOR(state, { user, hall, tableNumber }) {
      console.log(user);
      state.factor.sho_Mobile = user.phonE_NUMBER;
      state.factor.taF_NAME = user.name;
      state.factor.tedad = user.count;

      state.factor.saloonID = hall;
      state.factor.desK_NUMBER = tableNumber;
    },
    SET_FACTOR_DETAIL(
      state,
      { deliveryDelay, description, paymentType, cartTrackingNo, PosNo }
    ) {
      state.factor.deliveryDelay = deliveryDelay;
      state.factor.description = description;
      state.factor.paymentType = paymentType;
      state.factor.cartTrackingNo = cartTrackingNo;
      state.factor.PosNo = PosNo;
    },
    REMOVE_FACTOR(state) {
      state.factor = {};
    },
    EDIT_FACTOR(state, factor) {
      state.factor = factor;
    },
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
  },
  actions: {
    login({ commit }, { UserName, Password }) {
      const params = new FormData();
      params.append("Grant_Type", "password");
      params.append("Client_Id", "takhtjamshid");
      params.append("Client_Secret", process.env.VUE_APP_CLIENT_SECRET);
      params.append("scope", "WebApi");
      params.append("UserName", UserName);
      params.append("Password", Password);

      return new Promise((resolve, reject) => {
        login(params)
          .then((resp) => {
            commit("SET_TOKEN", resp.data.access_token);
            httpClient.defaults.headers.common["Authorization"] =
              "Bearer " + resp.data.access_token;
            getUserInfo()
              .then((resp) => {
                commit("SET_USER", resp.data.result);
                resolve();
                fcmToken()
                  .then((token) => postFCMToken(token))
                  .catch(console.log("خطاردرfirebase"));
              })
              .catch(() => reject());
          })
          .catch(() => reject());
      });
    },
    logout({ commit }) {
      commit("REMOVE_TOKEN");
      router.push("/login?reLogin=true");
    },
    setInitialFactor({ commit }, { user, hall, tableNumber }) {
      commit("SET_INITIAL_FACTOR", { user, hall, tableNumber });
      router.push("/submit-order/menu");
    },
    setFactorDetail(
      { commit },
      { deliveryDelay, description, paymentType, cartTrackingNo, PosNo }
    ) {
      commit("SET_FACTOR_DETAIL", {
        deliveryDelay,
        description,
        paymentType,
        cartTrackingNo,
        PosNo,
      });
    },
    removeFactor({ commit }) {
      commit("REMOVE_FACTOR");
    },
    editFactor({ commit }, factor) {
      commit("EDIT_FACTOR", factor);
    },
  },
  modules: {
    cart,
  },
  getters: {
    isLoggedIn: (state) => state.token !== "",
    token: (state) => "Bearer " + state.token,
    editFactor: (state) => state.factor.factoR_ID !== undefined,
  },
});
